import { merge } from 'lodash'
import * as CONST from './const'

const initialState = {
  dialogs: {},
  activeDialog: null,
  contactList: {
    contacts: [],
    loading: false,
  },
}

export function chat(state = initialState, action) {
  switch (action.type) {
    case CONST.FETCH_CONTACTS:
      return {
        ...state,
        contactList: { loading: true, contacts: [] },
      }

    case CONST.FETCH_CONTACTS_SUCCESS:
      return {
        ...state,
        contactList: { loading: false, contacts: action.contacts },
      }

    case CONST.SET_DIALOG:
      if (action.dialog === null) {
        const { [action.dialogId]: toExclude, ...allDialogs } = state.dialogs
        return {
          ...state,
          dialogs: allDialogs,
        }
      } else {
        return {
          ...state,
          dialogs: merge(state.dialogs, { [action.dialogId]: action.dialog }),
        }
      }

    case CONST.SET_ACTIVE_DIALOG:
      return {
        ...state,
        activeDialog: action.dialogId,
      }

    case CONST.RESET_CHAT:
      return initialState

    default: {
      return state
    }
  }
}
